import Widget, { ValueOptionConfigurationField, WidgetConfigurationField, WidgetType } from 'domain/entity/widget';

export const asWidget = (widgetItem: WidgetJsonType): Widget =>
    new Widget(
        widgetItem.id.toString(), // Needed for json-server
        widgetItem.name,
        widgetItem.settings.type as WidgetType,
        widgetItem.configuration.preset,
        asWidgetConfigurationField(widgetItem.configuration.fields),
        asWidgetConfigurationField(widgetItem.settings.options)
    );

const asWidgetConfigurationField = (fields: WidgetConfigurationFieldJsonType[]) =>
    fields.map((field) => new WidgetConfigurationField(field.key, field.value));

export type WidgetConfigurationFieldJsonType = { key: string; value: string };
export type WidgetOptionConfigurationFieldJsonType = { key: string; value: ValueOptionConfigurationField };

export type WidgetJsonType = {
    id: string;
    name: string;
    settings: {
        type: string;
        options: WidgetConfigurationFieldJsonType[];
    };
    configuration: {
        preset: string;
        fields: WidgetConfigurationFieldJsonType[];
    };
};
